module.exports = __webpack_public_path__ + "img/Agroalimentario1.e5037760.jpg";